import React, { ReactNode } from 'react'

import AlertMessage from 'src/comps/AlertMessage'
import Notifications from 'src/comps/Notifications'
import PurchaseReminder from 'src/comps/Notifications/PurchaseReminder/container'

import {
  THEMES,
  THEME_PRIMARY,
  THEME_SECONDARY,
  THEME_TERTIARY,
} from 'client/components/Header/constants'
import { useBusiness } from 'src/hooks/useBusiness'
import { AFFILIATE_EBOOKING } from 'src/constants/affiliates'
import styles from './styles.module.css'
import { cn } from '@s4l/utility-css'

export interface HeaderWithSlotsProps {
  left: ReactNode
  center?: ReactNode
  right: ReactNode
  bottom?: ReactNode
  theme?: (typeof THEMES)[number]
  fixed?: boolean
}

const HeaderWithSlots: React.FC<HeaderWithSlotsProps> = ({
  left,
  right,
  center,
  bottom,
  theme = THEME_PRIMARY,
  fixed = false,
}) => {
  const { affiliate } = useBusiness()
  const isEbooking = affiliate === AFFILIATE_EBOOKING

  return (
    <header
      className={cn(styles.header, {
        [styles.fixed]: fixed,
        [styles.themePrimary]: theme === THEME_PRIMARY,
        [styles.themeSecondary]: theme === THEME_SECONDARY,
        [styles.themeTertiary]: theme === THEME_TERTIARY,
        [styles.themeEbooking]: isEbooking,
      })}
    >
      <AlertMessage />
      <Notifications>
        <PurchaseReminder />
      </Notifications>

      <div className={cn(styles.headerInner, { [styles.withCenterChildren]: !!center })}>
        {left}
        {center}
        {right}
      </div>
      {bottom}
    </header>
  )
}

export default HeaderWithSlots
